import base from './side-overlay'
import { gsap } from 'gsap'

export default {
	...base,
}
